module.exports = __webpack_public_path__ + "img/blue-button.9e06ae8f.png";